module.exports = __webpack_public_path__ + "static/media/Account.bbea30a2.svg";